export default __webpack_public_path__ + "static/media/icon_harga_terendah.67ca64db.svg";